import styled, { css } from 'styled-components';

const oneColStyles = (props) => {
  if (props.$oneCol) {
    return css`
      width: 100%;
      display: block;
    `;
  }
};

export const PromotedLinks = styled.div`
  ${(props) => props.theme.fontStyles}
  margin-top: 15px;

  @media screen and (min-width: ${(props) => props.theme.theme_vars.breakpoints.s}) {
    display: -ms-flex;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
  }
  @media screen and (min-width: calc(${(props) => props.theme.theme_vars.breakpoints.l} + 60px)) {
    margin-top: 45px;
  }
  flex-direction: ${(prop) => (prop.oneCol ? 'column' : 'inherit')};
`;

export const PromotedLink = styled.a`
  display: block;
  height: 100%;

  /* Memorial theme styling - horizontal layout like HeadingWithIconLink */
  ${props => props.theme.is_memorial && props.theme.theme_vars && props.theme.theme_vars.theme_name && (props.theme.theme_vars.theme_name.includes('Memorial')) && `
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    padding: 20px;
  `}
  @media screen and (min-width: calc(${(props) => props.theme.theme_vars.breakpoints.l} + 60px)) {
    box-sizing: border-box;
  }
  background: ${(props) => props.theme.theme_vars.colours.white};
  background: ${(props) => props.theme.theme_vars.colours.white}F2;
  border-radius: 3px;
  box-shadow:
    0px -4px 0px 0px ${(props) => props.theme.theme_vars.colours.action} inset,
    0px 4px 15px rgba(0, 0, 0, 0.11);
  -webkit-box-shadow:
    0px -4px 0px 0px ${(props) => props.theme.theme_vars.colours.action} inset,
    0px 4px 15px rgba(0, 0, 0, 0.11);
  -moz-box-shadow:
    0px -4px 0px 0px ${(props) => props.theme.theme_vars.colours.action} inset,
    0px 4px 15px rgba(0, 0, 0, 0.11);

  padding: 20px 15px;
  width: 100%;
  margin-bottom: 15px;

  span {
    ${(props) => props.theme.linkStyles};

    /* Memorial theme - larger text like Heading component */
    ${props => props.theme.is_memorial && props.theme.theme_vars && props.theme.theme_vars.theme_name && (props.theme.theme_vars.theme_name.includes('Memorial')) && `
      font-size: 24px;
      font-size: 1.3rem;
      line-height: 1.4;
      margin-top: 0;
      margin-left: 15px;

      @media screen and (min-width: ${props.theme.theme_vars.breakpoints.m}) {
        font-size: 36px;
        font-size: 1.5rem;
        line-height: 1.3;
      }
    `}
  }

  [data-testid="DynamicIcon"] {
    .service-icon-hover {
      display: none;
    }

    /* Regular theme - icon above text */
    margin-bottom: 10px;

    /* Memorial theme - icon on left */
    ${props => props.theme.is_memorial && props.theme.theme_vars && props.theme.theme_vars.theme_name && (props.theme.theme_vars.theme_name.includes('Memorial')) && `
      margin-bottom: 0;
      margin-right: 0;
    `}
  }

  &:hover,
  &:focus {
    [data-testid="DynamicIcon"] {
      .service-icon {
        display: none;
      }
      .service-icon-hover {
        display: block !important;
      }
    }
  }

  &:hover {
    background: ${(props) => props.theme.theme_vars.colours.white};
  }

  &:focus {
    ${(props) => props.theme.linkStylesFocus};
    box-shadow:
      0 0 0 2px ${(props) => props.theme.theme_vars.colours.black},
      0 0 0 4px ${(props) => props.theme.theme_vars.colours.focus};
    -webkit-box-shadow:
      0 0 0 2px ${(props) => props.theme.theme_vars.colours.black},
      0 0 0 4px ${(props) => props.theme.theme_vars.colours.focus};
    -moz-box-shadow:
      0 0 0 2px ${(props) => props.theme.theme_vars.colours.black},
      0 0 0 4px ${(props) => props.theme.theme_vars.colours.focus};
    
    span {
      color: ${(props) => props.theme.theme_vars.colours.black};
    }
  }
  &:active {
    ${(props) => props.theme.linkStylesActive};
    transform: translateY(3px);
    box-shadow:
      0px -1px 0px 0px ${(props) => props.theme.theme_vars.colours.black} inset,
      0px 4px 15px rgba(0, 0, 0, 0.11);
    -webkit-box-shadow:
      0px -1px 0px 0px ${(props) => props.theme.theme_vars.colours.black} inset,
      0px 4px 15px rgba(0, 0, 0, 0.11);
    -moz-box-shadow:
      0px -1px 0px 0px ${(props) => props.theme.theme_vars.colours.black} inset,
      0px 4px 15px rgba(0, 0, 0, 0.11);
  }
  @media screen and (min-width: ${(props) => props.theme.theme_vars.breakpoints.s}) {
    width: 100%;
    margin-right: 15px;
    flex: 0 0 calc(50% - 38px);
    &:nth-of-type(2n) {
      margin-right: 0;
    }
  }

  @media screen and (min-width: ${(props) => props.theme.theme_vars.breakpoints.m}) {
    width: 100%;
    margin-right: 30px;

    margin-bottom: ${(prop) => (prop.oneCol ? '20px' : '0px')};
    padding: 30px;
    flex: 1;

    &:nth-of-type(2n) {
      margin-right: 30px;
    }
    &:last-of-type {
      margin-right: 0;
    }
  }
  ${oneColStyles}
`;
